import { Icon, Typography } from "@drone-js/core";
import { Component, type ErrorInfo, type PropsWithChildren } from "react";
import { reporter } from "../functions/reporter";
import { type ErrorStack, ErrorStackRenderer } from "./ErrorStackRenderer";
import { VStack } from "./Stack";

export class ErrorBoundary extends Component<PropsWithChildren, { error: ErrorStack | undefined }> {
    constructor(props: PropsWithChildren) {
        super(props);
        this.state = { error: undefined };
    }

    static getDerivedStateFromError(error: Error) {
        return {
            error: {
                instance: error,
            },
        };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        if (typeof error !== "undefined") {
            reporter.error(
                `Error at ErrorBoundary, name: ${error.name} \n message: ${error.message} \n stack: ${info.componentStack}`,
            );
        }
    }

    render() {
        if (this.state.error) {
            // You can render any custom fallback UI
            return (
                <VStack height="100dvh" width="100%" gap="16" alignItems="center" justifyContent="center" px="16">
                    <Icon id="fill.symbol.stack-base" size="48" color="base.default" />
                    <VStack gap="8" alignItems="center">
                        <Typography variant="heading-l" textAlign="center">
                            An error occurred with this application
                        </Typography>
                        <Typography variant="body-s" textAlign="center">
                            Something went wrong. Please try again later.
                        </Typography>
                    </VStack>
                    <ErrorStackRenderer {...this.state.error} />
                </VStack>
            );
        }

        return this.props.children;
    }
}
